// src/components/admin/AddCategoryModal.jsx
import React, { useState } from 'react';
import { BsX } from 'react-icons/bs';
import { useCategoryStore } from '../../store/serviceStore';
import { toast } from 'react-toastify';

const AddCategoryModal = ({ isCategoryModalOpen, closeCategoryModal }) => {

    const { categoryAddLoading, createCategory } = useCategoryStore();

    const [formData, setFormData] = useState({
        name: '',
        description: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.name.trim()) {
            toast.error("Le nom de la catégorie est requis");
            return;
        }

        try {

            await createCategory(formData);

            handleClose();
        } catch (error) {
            // L'erreur est déjà gérée dans le store
        }
    };

    const handleClose = () => {
        setFormData({
            name: '',
            description: ''
        });
        closeCategoryModal();
    };

    if (!isCategoryModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white  w-full max-w-md">
                {/* En-tête */}
                <div className="flex justify-between items-center p-6 border-b border-gray-200">
                    <h2 className="font-poppins font-semibold text-[18px] text-title">Nouvelle catégorie</h2>
                    <button
                        onClick={handleClose}
                        className="p-2 hover:bg-gray-100  transition-colors"
                        disabled={categoryAddLoading}
                    >
                        <BsX size={24} />
                    </button>
                </div>

                {/* Formulaire */}
                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    {/* Nom de la catégorie */}
                    <div>
                        <label className="block font-poppins font-medium text-[15px] text-subtitle mb-2">
                            Nom de la catégorie *
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                            disabled={categoryAddLoading}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary-500 disabled:bg-gray-50 disabled:cursor-not-allowed font-nunito text-[14px] text-text"
                            placeholder="Entrez le nom de la catégorie"
                        />
                    </div>

                    {/* Description */}
                    <div>
                        <label className="block font-poppins font-medium text-[15px] text-subtitle mb-2">
                            Description
                        </label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            rows={3}
                            disabled={categoryAddLoading}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-secondary-500 disabled:bg-gray-50 disabled:cursor-not-allowed font-nunito text-[14px] text-text"
                            placeholder="Description de la catégorie"
                        />
                    </div>

                    {/* Boutons */}
                    <div className="flex justify-end gap-3 pt-4">
                        <button
                            type="button"
                            onClick={handleClose}
                            disabled={categoryAddLoading}
                            className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-nunito font-semibold text-[14px]"
                        >
                            Annuler
                        </button>
                        <button
                            type="submit"
                            disabled={categoryAddLoading}
                            className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 font-nunito font-semibold text-[14px]"
                        >
                            {categoryAddLoading && (
                                <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
                            )}
                            {categoryAddLoading ? 'Création...' : 'Créer la catégorie'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddCategoryModal;